import { useTranslation } from 'react-i18next';

import Button from '../../../components/buttons/Button';

export const RedeemTooltip = (props: { handleClick: VoidFunction }) => {
  const { t } = useTranslation();

  return (
    <>
      <p>
        <span>{t('onboarding.inThe')} </span>
        <strong>{t('common.redeem')} </strong>
        <span>{t('onboarding.sectionYouCanRedeem')}</span>
      </p>
      <Button btnType="main" onClick={props.handleClick}>
        {t('buttons.gotIt')}
      </Button>
    </>
  );
};
